import { useTheme } from '@ori-ui/mui';
import { generateSrcSet, getImageVariants, type ImageSizesHelperParams } from '@ori/image-sizes-helper';
import { ImagePlaceholder } from '@ori/presentation-components';
import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { SEARCH_PREVIEW_IMAGE, SEARCH_PREVIEW_IMAGE_PLACEHOLDER, SEARCH_PREVIEW_IMAGE_SIZE } from './constants';
import { ImageWrapper, Root } from './styles';
import type { SearchPreviewImageProps } from './types';

export const SearchPreviewImage: FC<SearchPreviewImageProps> = ({ imageUrl, name }) => {
  const { getTestId } = useTestId();
  const theme = useTheme();

  if (!imageUrl) {
    return (
      <ImageWrapper>
        <ImagePlaceholder
          testId={getTestId(SEARCH_PREVIEW_IMAGE_PLACEHOLDER)}
          height={SEARCH_PREVIEW_IMAGE_SIZE}
          width={SEARCH_PREVIEW_IMAGE_SIZE}
        />
      </ImageWrapper>
    );
  }

  const imagesVariants: ImageSizesHelperParams = {
    url: imageUrl,
    imageFormat: 'WebP',
    backgroundColor: theme.palette.grey[100],
    imageSizeMultiplier: 2,
    params: [
      {
        width: SEARCH_PREVIEW_IMAGE_SIZE,
        height: SEARCH_PREVIEW_IMAGE_SIZE,
        quality: 90,
      },
    ],
  };

  return (
    <ImageWrapper>
      <Root
        data-testid={getTestId(SEARCH_PREVIEW_IMAGE)}
        alt={name ?? ''}
        src={imageUrl}
        srcSet={generateSrcSet(getImageVariants(imagesVariants))}
        sizes={`${SEARCH_PREVIEW_IMAGE_SIZE}px`}
      />
    </ImageWrapper>
  );
};
